






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiUser from '@/api/user'
import { toSubArray } from '@/utils/groupBy'
import { directPayloadQuery } from '@/utils/api' 
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'
import cloneDeep from 'clone-deep'
import * as rules from '@/utils/validationRules'
import FormSejour from '@/components/reception/FormSejour.vue'


@Component({
  name: 'ModifySejour', 
  props: {
    sejourId:Number,
    useUser:{
      type:Boolean,
      default:false
    }
  },
  components: {FormSejour},
})

export default class ModifySejour extends Vue {
  sejourId!: number  
  useUser!:boolean

}
